import React from "react";
import { Link } from "react-router-dom";
import "../components css/card.css"
import { useTranslation } from "react-i18next";
function Card(props){
    let {t} = useTranslation();
        return(
            <>
            <div className="col-md-6 col-lg-4" >
                <div className="card" style={{ width:'30rem'} }>
                    <img src={props.Card.img} className="card-img-top" alt="I"/>
                    <div className="card-body">
                        <h4 className="card-title">{t(props.Card.title)}</h4>
                        <Link onClick={()=>{window.scrollTo(0,0)}} to ={`/story/${props.Card.id}`} className="btn btn-sm btn-dark storiesBut">{t("RMore")}</Link>
                    </div>
                </div>
            </div>
            </>
        )
}
export default  Card